module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/reason_img-b0ff13ed169b91bba9621d61143d631b.svg";